export function listingIdsPath(ids: readonly unknown[]): string {
  if (
    !ids.length ||
    ids.length > 500 ||
    ids.some((id) => typeof id !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(id))
  ) {
    throw new Error('Invalid listing identifiers');
  }
  return (ids as string[]).map((id) => encodeURIComponent(id)).join(',');
}
